import { API_AXIOS_INSTANCE } from "@elation/api-client/src/core";
import { BEARER_TOKEN_KEY } from "@src/auth/client.constants";
import { IS_CHROME_EXTENSION, IS_IN_IFRAME, SERVICE_URL } from "@src/env";
import { iframeStore } from "@src/features/iframe";
import { getAccessToken } from "@src/okta/tokenManager";
import { getCsrfToken, setCsrfFromResponse } from "@src/utils/auth/csrf";

API_AXIOS_INSTANCE.defaults.baseURL = SERVICE_URL;

API_AXIOS_INSTANCE.interceptors.request.use(async (config) => {
  if (IS_IN_IFRAME) {
    config.headers["X-EL8-In-Iframe"] = true;
    config.headers["X-EL8-EHR"] = iframeStore.getState().ehr;
  }

  if (config.url?.startsWith("/gw/stitch-web")) {
    config.url = config.url.replace("/gw/stitch-web", "");
  }

  if (IS_CHROME_EXTENSION) {
    config.headers["X-EL8-API-CLIENT-CONTEXT"] = "extension";
  } else {
    config.headers["X-EL8-API-CLIENT-CONTEXT"] = "browser";
  }

  const csrfToken = getCsrfToken();
  const accessToken = await getAccessToken();

  config.headers["X-CSRFToken"] = csrfToken || "";

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  if (IS_IN_IFRAME) {
    const token = localStorage.getItem(BEARER_TOKEN_KEY);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

API_AXIOS_INSTANCE.interceptors.response.use((response) => {
  setCsrfFromResponse();
  return response;
});
